import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import setLayout from "shared/set-layout"
import UsersConfirmation from "components/users/confirmation"

/** @typedef {object} RoutesFrontUsersConfirmationProps */

/** @typedef {object} RoutesFrontUsersConfirmationState */

/**
 * @extends {ShapeComponent<RoutesFrontUsersConfirmationProps, RoutesFrontUsersConfirmationState>}
 */
class RoutesFrontUsersConfirmation extends ShapeComponent {
  render() {
    setLayout("front")

    return (
      <div className="routes--front--users--confirmation">
        <UsersConfirmation />
      </div>
    )
  }
}

export default memo(shapeComponent(RoutesFrontUsersConfirmation))
